import ApplicationController from '../application_controller'
import { wsInitialize } from 'channels/wsInitialize'

class TimeTableEntriesController extends ApplicationController {
  connect () {
    this.subscription = wsInitialize({
      channel: 'Employees::TimetableChannel',
      onReceive: this.onReceive
    })
  }

  disconnect () {
    this.subscription.unsubscribe()
  }

  onReceive (data) {
    const id = `total_for_${data.date}`
    const element = document.getElementById(id)
    const countTotalTime = (links) => {
      let totalHour = 0
      let totalMinutes = 0
      links.forEach(entry => {
        const [hours, minutes] = entry.innerText.split(':')
        totalHour += parseInt(hours)
        totalMinutes += parseInt(minutes)
      })
      totalHour += Math.floor(totalMinutes / 60)
      totalMinutes = totalMinutes % 60

      const displayHour = totalHour.toString().padStart(2, '0')
      const displayMinutes = totalMinutes.toString().padStart(2, '0')
      return `${displayHour}:${displayMinutes}`
    }

    if (element) {
      const groupParentElement = element.parentElement.parentElement
      const links = groupParentElement.querySelectorAll('.time-table-editable > a')
      element.innerHTML = data.working_time

      if (data.working_time !== '00:00') {
        element.className = element.className + ' bg-warning'
      }

      groupParentElement.querySelector('.total').innerHTML = countTotalTime(links)
    }
  }
}

export default TimeTableEntriesController
